module.exports = __webpack_public_path__ + "img/registration-02.fb1445d1.png";